import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography, Grid } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes__default from 'prop-types';
import { textStyleType } from '../../common/PropShapes.js';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    titleTextCtaParentContainer: _defineProperty({
      width: "100%",
      padding: theme.spacing(7.5, 2)
    }, theme.breakpoints.down("sm"), {
      padding: theme.spacing(10, 2)
    }),
    horizontalAlignCenter: _defineProperty({
      margin: "0 auto",
      width: "fit-content"
    }, theme.breakpoints.up("sm"), {
      padding: theme.spacing(0, 10)
    }),
    p0: {
      padding: 0,
      marginTop: "auto"
    },
    boxOuter: {
      "&:nth-child(odd) > div": {
        backgroundColor: theme.palette.background.white
      },
      "&:nth-child(even) > div": {
        backgroundColor: "#F2F8FC"
      }
    },
    box: {
      height: "100%",
      borderRadius: "9px",
      border: "1px solid",
      borderColor: theme.palette.secondary["200"],
      padding: theme.spacing(4, 3),
      maxWidth: theme.spacing(74.375),
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    imageWrapper: _defineProperty({
      height: theme.spacing(8.75),
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.up("sm"), {
      marginBottom: theme.spacing(1)
    }),
    mb3: {
      marginBottom: theme.spacing(3)
    },
    textCenter: {
      textAlign: "center"
    }
  };
});
var TitleTextCTA = function TitleTextCTA(_ref) {
  var title = _ref.title,
    titleStyle = _ref.titleStyle,
    bgColor = _ref.bgColor,
    cards = _ref.cards;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.titleTextCtaParentContainer,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle && titleStyle.headingVariant ? titleStyle.headingVariant : "h1",
    component: "h2",
    align: titleStyle && titleStyle.textAlignment ? titleStyle.textAlignment.toLowerCase() : "center",
    className: classes.mb3
  }, title), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    justify: "center"
  }, (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && (cards === null || cards === void 0 ? void 0 : cards.map(function (card, cardIdx) {
    var _card$ctas, _card$ctas2;
    return /*#__PURE__*/React__default.createElement(Grid, {
      key: cardIdx,
      item: true,
      className: classes.boxOuter
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classes.box
    }, (card === null || card === void 0 ? void 0 : card.image) && /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.imageWrapper, classes.horizontalAlignCenter)
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(card === null || card === void 0 ? void 0 : card.image.url, {
        width: 70,
        height: 70
      }),
      alt: card === null || card === void 0 ? void 0 : card.image.alt
    })), /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.maxWidth440, classes.horizontalAlignCenter)
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h4",
      component: "div",
      align: "center",
      className: classes.mb3
    }, card === null || card === void 0 ? void 0 : card.title)), /*#__PURE__*/React__default.createElement("div", {
      className: clsx(classes.maxWidth440, classes.horizontalAlignCenter)
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1",
      align: "center",
      className: classes.mb3
    }, card === null || card === void 0 ? void 0 : card.description)), /*#__PURE__*/React__default.createElement(Grid, {
      container: true,
      spacing: 1,
      className: clsx(classes.horizontalAlignCenter, classes.p0),
      justify: "center"
    }, (card === null || card === void 0 || (_card$ctas = card.ctas) === null || _card$ctas === void 0 ? void 0 : _card$ctas.length) > 0 && (card === null || card === void 0 || (_card$ctas2 = card.ctas) === null || _card$ctas2 === void 0 ? void 0 : _card$ctas2.map(function (cta, ctaIdx) {
      var _BUTTON_TYPES$cta$typ, _BUTTON_TYPES$cta$typ2, _BUTTON_TYPES$cta$typ3;
      return /*#__PURE__*/React__default.createElement(Grid, {
        item: true,
        key: ctaIdx
      }, /*#__PURE__*/React__default.createElement(CustomButton, {
        variant: (_BUTTON_TYPES$cta$typ = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ === void 0 ? void 0 : _BUTTON_TYPES$cta$typ.variant,
        color: ((_BUTTON_TYPES$cta$typ2 = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ2 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ2.variant) === "outlined" ? "black" : (_BUTTON_TYPES$cta$typ3 = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ3 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ3.color,
        href: cta === null || cta === void 0 ? void 0 : cta.url,
        size: "large",
        align: "center"
      }, cta === null || cta === void 0 ? void 0 : cta.label));
    }))), (card === null || card === void 0 ? void 0 : card.footnote) && card.footnote.trim() !== "" && /*#__PURE__*/React__default.createElement(Box, {
      mt: 3,
      px: 10,
      className: classes.textCenter
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      element: "p"
    }, card === null || card === void 0 ? void 0 : card.footnote))));
  }))));
};
TitleTextCTA.propTypes = {
  title: PropTypes__default.string,
  titleStyle: PropTypes__default.shape(textStyleType),
  bgColor: PropTypes__default.string,
  cards: PropTypes__default.array
};

export { TitleTextCTA as default };
//# sourceMappingURL=TitleTextCTA.js.map
